import { Delimiter } from 'src/shared/design-system/Utilities/TextReplace';
import previewImage from './Post/Images/preview.png';

export const COMPOSER_TEXT = {
  BUTTON: {
    CHANGE: 'Change',
    PROMO_CODE: 'Add Promo',
    HAS_PROMO_CODE: 'Promo Attached',
    POST: 'Post',
    UPLOAD: 'Upload',
  },
  FOOD_ITEM: {
    LABEL: 'Link to',
    PLACEHOLDER: 'Choose menu item (optional)',
  },
  INPUT: {
    PLACEHOLDER: 'Type a message',
    PLACEHOLDER_FIRST_POST: 'Create your first post',
  },
} as const;

export const FOLLOW_TEXT = {
  FOLLOWERS: {
    SINGULAR: 'Follower',
    PLURAL: 'Followers',
    NONE_MESSAGE: {
      HEADER: 'You don’t have any followers yet.',
      TEXT: 'You can spread the word by inviting past customers to follow you. After a positive review is a great time to reach out & invite a past customer to follow you.',
    },
  },
  FOLLOWING: {
    NONE_MESSAGE: {
      HEADER: 'You don’t follow any shefs yet.',
      TEXT: 'Follow a few shefs you’ve ordered from to keep updated with their latest stories, dishes, and promos!',
    },
  },
  ORDERS: {
    SINGULAR: 'Order',
    PLURAL: 'Orders',
    NONE: 'No Orders',
  },
  MENU: {
    VIEW: 'See Menu',
    MESSAGE: `Message ${Delimiter}`,
    UNFOLLOW: 'Unfollow Shef',
  },
};

export const FOOD_ITEM_DROPDOWN_TEXT = {
  LABEL: 'Link to',
  PLACEHOLDER: 'Choose menu item (optional)',
} as const;

export const GENERATED_PROMO_TEXT = {
  MIN_ORDER: `Minimum order value of ${Delimiter} required.`,
  VALUE_OFF: `Get ${Delimiter} off your next order!`,
  USE_PROMO: `Use the promo code ${Delimiter}.`,
  SPLIT_TEXT_REGEX: `Get ([0-9%$])* off your next order! Use the promo code`,
};

export const GENERATED_PROMO_TEXT_REGEX = `${GENERATED_PROMO_TEXT.VALUE_OFF.replace(
  Delimiter,
  '([0-9%$]*)'
)} ${GENERATED_PROMO_TEXT.USE_PROMO.replace(Delimiter, '([A-Za-z0-9]*)')}`;

export const POST_TEXT = {
  IMAGE: {
    ALT: 'Shef Post Image',
  },
  VISIT_MENU_BUTTON: 'Visit my menu',
  HEADER: {
    MENU: {
      MESSAGE: `Message ${Delimiter}`,
      REPORT: 'Report Abuse',
      UNFOLLOW: 'Unfollow Shef',
    },
  },
  BODY: {
    BUTTONS: {
      REDEEM_CODE: 'Redeem this code',
      VISIT_MENU: 'Visit my menu',
    },
  },
  FOOTER: {
    BUTTONS: {
      CANCEL: 'Cancel',
      DELETE: 'Delete',
      SAVE: 'Save',
    },
    DELETE_TEXT: 'Are you sure you want to delete?',
    MENU: {
      EDIT: 'Edit Post',
      DELETE: 'Delete Post',
    },
  },
  PREVIEW_DATA: {
    comment: `I’ve got a brand new menu item, hot off the stove! Try my Honduran Baledas before they sell out - these are my favorite Central American dish ever and they won’t last!`,
    date: 'April 30th 12:24 PM',
    mediaUrl: previewImage,
    showViewsAndVisits: true,
    shefId: '',
    autoFormatDate: false,
  },
  PREVIEW: {
    TITLE: "Here's what a post looks like:",
  },
};

export const WELCOME_TEXT = {
  HEADER: `Welcome to Shef Social! Here’s where you can share menu updates, promos, and more with your followers. A few tips to get you started:`,
  POST: `Post things that entice your followers to order. Try sharing new menu updates, promo codes, or a story on how & why you make your food.`,
  FOLLOW: `Most people follow shefs while browsing. Make sure your menu photos & descriptions are enticing!`,
};
